import React from "react";
import {
  CardAmericanExpress,
  CardDinnerClub,
  CardDiscover,
  CardJsb,
  CardMasterCard,
  CardUnionPay,
  CardVisa,
  PayPalIcon,
  CreditCardIcon,
} from "./icons";

export function getCardBrandIcon (brand = 'card') {
  switch (brand.toLowerCase()) {
    case 'paypal':
      return <PayPalIcon />;
    case 'card':
      return <CreditCardIcon />;
    case 'visa':
      return <CardVisa />;
    case 'mastercard':
      return <CardMasterCard />;
    case 'amex':
    case 'american express':
      return <CardAmericanExpress />;
    case 'discover':
      return <CardDiscover />;
    case 'diners':
      return <CardDinnerClub />;
    case 'jcb':
      return <CardJsb />;
    case 'unionpay':
      return <CardUnionPay />;
    default:
      return null;
  }
}
